import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { H2HComponent } from './h2h.component';
import { H2HResolverService } from './h2h-resolver.service';

import { ComponentModule } from '@/components/component.module';

@NgModule({
    declarations: [H2HComponent],
    imports: [CommonModule, ComponentModule, RouterModule.forChild([{ path: '', component: H2HComponent }])],
    providers: [H2HResolverService],
})
export class H2hModule {}
